import React, { useEffect, useState } from 'react'
import './Resume.css'
import './Common.css'

import resumeDataTr from '../data/jsons/resume.tr.json'
import resumeDataEn from '../data/jsons/resume.en.json'
import cvEnglish from '../documents/Tuna-Mus-CV-English-2026.pdf';
import cvTurkish from '../documents/Tuna-Mus-CV-Türkçe-2026.pdf';

function Resume() {
    const [isEnglish, setIsEnglish] = useState(
        localStorage.getItem('pageLanguage') === 'true'
    );

    useEffect(() => {
        const handleLangChange = () => {
            setIsEnglish(localStorage.getItem('pageLanguage') === 'true');
        };
        window.addEventListener("languageChange", handleLangChange);
        return () => {
            window.removeEventListener("languageChange", handleLangChange);
        };
    }, []);

    const resumeData = isEnglish ? resumeDataEn : resumeDataTr;

    const downloadCv = () =>{
        const cvDocument = document.createElement("a");
        cvDocument.href = isEnglish ? cvEnglish : cvTurkish;
        cvDocument.download = isEnglish ? "Tuna-Mus-CV-English-2026.pdf" : "Tuna-Mus-CV-Türkçe-2026.pdf";
        cvDocument.click();
    }

    return(
        <div id='Resume-Container' className='Containers'>
            <div className='Top-Section'>
                <p className='Page-Header'>{resumeData.header.title}</p>
                <hr className='Header-Line'/>
                <div className='About-Text-Section'>
                    {resumeData.header.paragraphs.map((para, index) => (
                        <p key={index} className='Page-Text'>{para}</p>
                    ))}
                </div>
            </div>
            <div id='Resume-Items'>
                {resumeData.resumeItems.map((section, sectionIndex) => (
                    <div key={sectionIndex} className='Resume-Section'>
                        <p className='Resume-Title'>{section.title}</p>
                        <div className='Items'>
                            {section.item.map((detail, detailIndex) => (
                                <React.Fragment key={detailIndex}>
                                    <div className='Item-Header'>
                                        <p className='Item-Title'>{detail.title}</p>
                                        <p className='Item-Date'>{detail.date}</p>
                                    </div>
                                    
                                    {detail.sub && (
                                        <p className='Item-Subtitle'>{detail.sub}</p>
                                    )}
                                    
                                    {detail.paragraphs && detail.paragraphs[0] !== "" && (
                                        <ul className='Item-Paragraphs'>
                                            {detail.paragraphs.map((para, pIndex) => (
                                                <li key={pIndex} className='Item-Paragraph'>{para}</li>
                                            ))}
                                        </ul>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                ))}
                <button className='Id-Contact-Button Download-Button' onClick={downloadCv}>{isEnglish ? "Download my CV" : "Özgeçmiş İndir"}</button>
            </div>
        </div>

    )
}

export default Resume